import { createContext } from "react";

export const LoadingContext = createContext({
    contextIsLoading: null,
    setContextIsLoading: (loading) => {}
});

